<template>
  <RevDialog :name="modalName" :title="i18n(translations.title)">
    <template #body>
      <div>
        <p class="px-9 py-7 text-center">
          {{ i18n(translations.body) }}
        </p>
      </div>
    </template>

    <template #footer>
      <div class="flex flex-col items-center">
        <RevButton
          class="mb-16"
          full-width="always"
          :loading="isLoading"
          variant="primary"
          @click="handleConfirm"
        >
          {{ i18n(translations.confirm) }}
        </RevButton>

        <RevLink @click="handleCancel">
          {{ i18n(translations.cancel) }}
        </RevLink>
      </div>
    </template>
  </RevDialog>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { HttpApiError } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'
import { RevButton } from '@ds/components/Button'
import { RevDialog } from '@ds/components/Dialog'
import { RevLink } from '@ds/components/Link'
import { closeModal } from '@ds/components/ModalBase'

import type { MarketShippingMethod } from '../../ShippingLegacy.types'
import { useShippingMethodApi } from '../../composables/useShippingMethodApi'

import { MODAL_NAME } from './DeleteShippingMethodModal.constants'
import translations from './DeleteShippingMethodModal.translations'

const props = defineProps<{
  marketShippingMethod: MarketShippingMethod
}>()

const emit = defineEmits(['deleted'])

const { openErrorToast } = useTheToast()
const { deleteShippingMethod } = useShippingMethodApi()
const i18n = useI18n()
const isLoading = ref(false)
const modalName = computed(() => MODAL_NAME + props.marketShippingMethod.id)

async function handleConfirm() {
  isLoading.value = true
  try {
    await deleteShippingMethod(props.marketShippingMethod)
    emit('deleted')
  } catch (error) {
    const { title, detail } = HttpApiError.fromAnyError(error as Error)
    openErrorToast({ title, content: detail })
  } finally {
    isLoading.value = false
    closeModal(modalName.value)
  }
}

function handleCancel() {
  closeModal(modalName.value)
}
</script>
